module.exports = __webpack_public_path__ + "img/check-circle-large.cdef4189.svg";